import { useEffect, useState } from 'react';

export default function useIsDesktopView() {
  const [isDesktopView, setIsDesktopView] = useState<boolean>(false);

  useEffect(() => {
    const viewportWidth = window.innerWidth;
    setIsDesktopView(viewportWidth > 1023);
  }, []);

  return isDesktopView;
}
